import React, { useState, useContext } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { makeStyles } from "@material-ui/styles";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CardSection from "../Common/cardSection";
import { AppContext } from "../Context";
import {
  getLocationsFromCourses,
  getTagsFromCourses,
  getWeeksFromCourses,
} from "./util";
import { SET_COURSEFILTER } from "../Context";
import { CloseButton } from "@mantine/core";

const useStyles = makeStyles((theme) => ({
  courseFilter: { height: theme.height },
  header: {
    // height: "50px",
    borderBottom: `1px solid ${theme.app.borderColor}`,
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
  },
  heading: {
    fontSize: "1.25rem",
    padding: "0 .7rem",
    marginTop: "0.45rem"
  },
  content: {
    height: "calc(100% - 50px)",
    overflow: "auto",
    background: theme.app.background[0],
  },
  bookable: {
    padding: "16px",
    background: theme.app.background[1],
  },
  label: {
    marginLeft: 0,
  },
  labelText: {
    fontSize: "0.875rem",
    color: theme.app.labelColor,
  },
  checkbox: {
    padding: "6px",
  },
  button: {
    color: theme.app.labelColor,
    borderRadius: "50%",
    cursor: "pointer",
    padding: "4px",
    transition: theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
    "&:hover": {
      backgroundColor: theme.app.hoverBackground[1],
    },
  },
  small: {
    fontSize: "0.75rem",
    color: theme.app.secondaryColor,
  },
}));

const CoursesFilter = (props) => {
  const { courses, close } = props;
  const classes = useStyles();
  const [activePanel, setActivePanel] = useState("tags");
  const language = useSelector((state) => state.language);
  const context = useContext(AppContext);
  const { state, dispatch } = context;
  const { courseFilter } = state;
  const setCourseFilter = (type, value, checked) =>
    dispatch({ type: SET_COURSEFILTER, payload: { type, value, checked } });
  const togglePanel = (panel) =>
    setActivePanel(panel === activePanel ? "" : panel);
  const tags = getTagsFromCourses(courses);
  const locations = getLocationsFromCourses(courses);
  const weeks = getWeeksFromCourses(courses);

  return (
    <main className={classes.courseFilter}>
      <div className={classes.header}>
          <CloseButton className={classes.button} onClick={close} aria-label={language.closeMenus}/>
      <h1 className={classes.heading}>{language.filter}</h1>

      </div>
      <div className={classes.content}>
        <div className={classes.bookable}>
          <FormControlLabel
            classes={{ label: classes.labelText }}
            className={classes.label}
            control={
              <Checkbox
                checked={courseFilter.showOnlyBookable}
                onChange={(e) =>
                  setCourseFilter("showOnlyBookable", null, e.target.checked)
                }
                className={classes.checkbox}
              />
            }
            label={language.showBookableOnly}
          />
        </div>
        <div>
          {locations.length > 1 && (
            <CardSection
              heading={language.locations}
              expanded={activePanel === "locations"}
              toggleExpanded={() => togglePanel("locations")}
            >
              {locations.map((l, i) => (
                <div key={i}>
                  <FormControlLabel
                    classes={{ label: classes.labelText }}
                    control={
                      <Checkbox
                        checked={courseFilter.locations.includes(l)}
                        onChange={(e) =>
                          setCourseFilter(
                            "locations",
                            e.target.value,
                            e.target.checked
                          )
                        }
                        className={classes.checkbox}
                        value={l}
                      />
                    }
                    label={l}
                  />
                </div>
              ))}
            </CardSection>
          )}
          <CardSection
            heading={language.startDate}
            expanded={activePanel === "startDates"}
            toggleExpanded={() => togglePanel("startDates")}
          >
            {weeks.map((w, i) => {
              const getWeek = moment()
                .year(w.substring(0, 4))
                .week(w.substring(4, 6));
              const week = `${language.week} ${w.substring(4, 6)}`;
              const days = `${getWeek.startOf("week").format("D/M")} - ${getWeek
                .endOf("week")
                .format("D/M")}`;

              const Label = () => (
                <div>
                  <span>{`${week} - `}</span>
                  <span className={classes.small}>{`(${days})`}</span>
                </div>
              );
              return (
                <div key={i}>
                  <FormControlLabel
                    classes={{ label: classes.labelText }}
                    control={
                      <Checkbox
                        checked={courseFilter.startDates.includes(w)}
                        onChange={(e) =>
                          setCourseFilter(
                            "startDates",
                            e.target.value,
                            e.target.checked
                          )
                        }
                        className={classes.checkbox}
                        value={w}
                      />
                    }
                    label={<Label />}
                  />
                </div>
              );
            })}
          </CardSection>

          <CardSection
            heading={language.tags}
            expanded={activePanel === "tags"}
            toggleExpanded={() => togglePanel("tags")}
          >
            {tags.map((t, i) => (
              <div key={i}>
                <FormControlLabel
                  classes={{ label: classes.labelText }}
                  control={
                    <Checkbox
                      checked={courseFilter.tags.includes(t)}
                      onChange={(e) =>
                        setCourseFilter(
                          "tags",
                          e.target.value,
                          e.target.checked
                        )
                      }
                      className={classes.checkbox}
                      value={t}
                    />
                  }
                  label={t}
                />
              </div>
            ))}
          </CardSection>
        </div>
      </div>
    </main>
  );
};

export default CoursesFilter;
